export function transformImage(src: string): { mobile: string; desktop: string } {
  const mobile = `https://www.creativefabrica.com/cdn-cgi/image/width=767,height=200,fit=crop,crop=top,format=webp/${src}`
  const desktop = `https://www.creativefabrica.com/cdn-cgi/image/format=webp/${src}`

  return {
    mobile,
    desktop,
  }
}
